import React, { useState } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';

import OverflowedContent from '@wix/da-shared-react/pkg/OverflowedContent';
import TextRenderer from '@wix/da-shared-react/pkg/TextRenderer';

import Button from '@wix/da-shared-react/pkg/Button';
import DeviantIdViewer from '@wix/da-shared-react/pkg/DaEditorWrapper/Viewer/DeviantId';
import Separator from '@wix/da-shared-react/pkg/Separator';

import Interests from '../Interests';
import { PapiEditorText } from '@wix/da-types-papi';
import { AboutMeMode } from '../types';
import s from './CollapsibleBio.scss';

interface Props {
  moduleId: number;
  moduleVersion: number;
  bio: PapiEditorText;
  interests?: {
    id: number;
    value: string;
  }[];
  mode: AboutMeMode;
}

const CollapsibleBio: React.FC<Props> = ({
  bio,
  interests,
  mode,
  moduleId,
  moduleVersion,
}) => {
  const { t } = useTranslation();
  const [isBioExpanded, setIsBioExpanded] = useState(false);

  return (
    <OverflowedContent maxHeight={360}>
      {isOverflowed => (
        <>
          <div
            className={classnames(
              s['bio'],
              isOverflowed &&
                !isBioExpanded &&
                mode === AboutMeMode.CARD &&
                s['collapsed'],
              !isOverflowed && mode === AboutMeMode.CARD && s['no-overflow']
            )}
          >
            <TextRenderer
              textContent={bio}
              legacyTheme={'default'}
              reactViewer={DeviantIdViewer}
              viewerKey={`bio-${moduleId}-${moduleVersion}`}
            />

            {interests && interests.length > 0 && (
              <>
                <Separator className={s['interests-separator']} />
                <Interests
                  className={classnames(s['no'])}
                  interests={interests}
                />
              </>
            )}
          </div>
          {isOverflowed && mode === AboutMeMode.CARD && (
            <Button
              className={classnames(
                s['expand-or-collapse-button'],
                !isBioExpanded && s['expand']
              )}
              view="b3"
              onClick={() => setIsBioExpanded(!isBioExpanded)}
            >
              {t(isBioExpanded ? 'common.showLess' : 'common.showMore')}
            </Button>
          )}
        </>
      )}
    </OverflowedContent>
  );
};
CollapsibleBio.displayName = 'CollapsibleBio';

export default CollapsibleBio;
